export enum ECompanyTabsEdit {
  DadosEmpresa = 1,
  Filiais = 2,
  UsuariosAdmin = 3,
  CentroCusto = 4,
  Colaboradores = 5,
  Medicos = 6,
  Atendentes = 7,
  Motivos = 8,
}
